import ListItem from "~/types/ListItemType";

export function isIdPresent(list: Array<ListItem>, id: Number) {
  return list.some((listItem) => listItem.id === id);
}
